import { el } from "../render/svg.js";

export interface Modal {
  overlay: HTMLElement;
  body: HTMLElement;
  close: () => void;
}

export function modal(root: HTMLElement, title: string): Modal {
  const overlay = el("div", "ed-overlay");
  const box = el("div", "ed-modal");
  const head = el("div", "ed-modal-head");
  head.appendChild(el("h2", undefined, title));
  const x = el("button", "ed-x", "✕") as HTMLButtonElement;
  x.type = "button";
  head.appendChild(x);
  const body = el("div", "ed-modal-body");
  box.append(head, body);
  overlay.appendChild(box);
  root.appendChild(overlay);
  const close = (): void => overlay.remove();
  x.addEventListener("click", close);
  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) close();
  });
  document.addEventListener("keydown", function esc(e) {
    if (e.key === "Escape") {
      close();
      document.removeEventListener("keydown", esc);
    }
  });
  return { overlay, body, close };
}
